var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card job-card",class:_vm.additionalClasses},[_c('div',{staticClass:"card-header font-weight-bold text-center"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('ul',{staticClass:"list-unstyled mb-0 job-card-list"},[_vm._t("body")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b316936","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/job/JobDetailsCard.vue
// module id = hnEp
// module chunks = 1